import React from 'react';
import {
	Button
} from "react-bootstrap";

import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import { helperFunctions as HF } from '../../../helper/helperFunctions';

class UserForm extends React.Component {
	constructor(props) {
		super(props);
		this.validatorUser = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
		this.state = {
			user: {
				...this.props.userPro,
				password: '',
				confirm_password: '',
				role_id: this.props.userPro.role_id || '',
				role: this.props.userPro.role || '',
			},
			submitted: false,
			formType: this.props.formTypePro || '',
			allowedFormatsStringMime: 'image/jpeg, image/png',
			allowedFormatsStringExt: 'jpg, png',
		};

		this.handleUser = this.handleUser.bind(this);
		this.handleUserSubmitForm = this.handleUserSubmitForm.bind(this);
		this.handleChangeRole = this.handleChangeRole.bind(this);
	}
	handleChangeRole(selectedOption, name) {
		if (name.action === 'select-option') {
			this.setState(prevState => ({
				user: {
					...prevState.user,
					role_id: selectedOption.value,
				    role: selectedOption.label,
			}
			}));
		}
		if (name.action === 'remove-value') {
			const rolesTemp = this.state.user.roles;
			rolesTemp.splice(rolesTemp.indexOf(name.removedValue.value), 1);
			this.setState(prevState => ({
				user: {
					...prevState.user,
					role_id: selectedOption.value,
				    role: selectedOption.label,
				}
			}))
		}
	}
	handleUser(e) {
		const { name, value } = e.target;
		this.setState({
			user: {
				...this.state.user,
				[name]: value
			}
		});
	}
	handleUserSubmitForm(e) {
		e.preventDefault();
		if (this.validatorUser.allValid()) {
			this.setState({ submitted: true }, function () {
				this.props.handleUserSubmit(this.state.user, this.state.formType);
			});
		} else {
			this.setState({ submitted: false });
			this.validatorUser.showMessages();
			this.forceUpdate();
		}
	}
	extractImageData = (value) => {
		const file = {};
		file['file'] = value['file'];
		file['name'] = value['name'];
		file['size'] = value['size'];
		file['extension'] = HF.returnExtFromImage(value['name']);
		file['preview'] = value['preview'];
		file['type'] = value['type'];
		file['lastModified'] = value['lastModified'];
		return file;
	}
	setResourceFile = (key, value) => {
		this.setState({
			user: { ...this.state.user, image: this.extractImageData(value) },
		});
	}
	removeFile = (key, index) => {
		this.setState({
			user: { ...this.state.user, image: null },
		});
	}
	render() {
		const { user, formType} = this.state;
		const { roles } = this.props;
		return (
			<form onSubmit={this.handleUserSubmitForm}>
				<div className="row">
					<div className="col-md-12">
						<div className='form-group'>
							<label htmlFor="email">Email<span className="requiredClass">*</span></label>
							<input type="text" name="user_name" className="form-control email_icon" value={user.user_name} onChange={this.handleUser} />
							{this.validatorUser.message('email', user.user_name, 'required|email')}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6">
						<div className='form-group'>
							<label htmlFor="name">First Name<span className="requiredClass">*</span></label>
							<input type="text" name="first_name" className="form-control" value={user.first_name} onChange={this.handleUser} />
							{this.validatorUser.message('first name', user.first_name, 'required')}
						</div>
					</div>
					<div className="col-md-6">
						<div className='form-group'>
							<label htmlFor="email">Last Name<span className="requiredClass">*</span></label>
							<input type="text" name="last_name" className="form-control " value={user.last_name} onChange={this.handleUser} />
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6">
						<div className='form-group'>
							<label htmlFor="password">Password<span className="requiredClass">*</span></label>
							<input type="password" autoComplete="off" name="password" className="form-control password_icon" value={user.password} onChange={this.handleUser} minLength="6" />
							{formType === 'add' &&
								this.validatorUser.message('password', user.password, 'required|min:6')
							}
						</div>
					</div>
					<div className="col-md-6">
						<div className='form-group'>
							<label htmlFor="confirm_password">Confirm Password<span className="requiredClass">*</span></label>
							<input type="password" autoComplete="off" name="confirm_password" className="form-control password_icon" value={user.confirm_password} onChange={this.handleUser} />
							{formType === 'add' &&
								this.validatorUser.message('confirm_password', user.confirm_password, 'required|min:6')
							}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className='form-group'>
							<label htmlFor="name">Select Role<span className="requiredClass">*</span></label>
							<Select
								value={HF.returnLabelWithValue(user.role_id, roles)}
								onChange={this.handleChangeRole}
								options={roles}
								isSearchable={true}
								// isMulti={true}
								placeholder={'Select Role'}
								isClearable={false}
							/>
							{this.validatorUser.message('roles', user.role_id, 'required')}
						</div>
					</div>
					{/* <div className="col-md-6 pofilePicContainer">
						{!this.state.user.image ?
							<div className='form-group dropzone_profileImage'>

								<FileUpload
									files={this.state.user.image}
									setResourceFile={this.setResourceFile}
									allowedFormatsStringMimePro={allowedFormatsStringMime}
									allowedFormatsStringExtPro={allowedFormatsStringExt}
									multiple={false}
								/>
							</div>
							:
							<ImagePreview
								filesToPreview={this.state.user.image}
								removeFile={this.removeFile}
							/>
						}
					</div> */}
				</div>

				<div className="row">
					<div className="col-md-12">
						<div className='text-center'>
							<Button type='submit' bsSize="large" bsStyle="info" className="backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm btn-default " >Save</Button>
							<Button bsSize="large" bsStyle="info" onClick={() => this.props.closeModel()} className="backButton pt-sm no_radius pb-sm primary btn btn-lg ml-sm mt-sm btn-info " >Cancel</Button>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

UserForm.defaultProps = {
	roles: []
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Users/UserForm.jsx